import { LayoutContainer } from '@petsmart-ui/sparky';
import cn from 'classnames';

import type { ContainerProps } from './types';

import './container.scss';

export type { ContainerProps } from './types';

export function Container({ roundTopCorners, children }: ContainerProps) {
    return (
        <LayoutContainer
            className={cn('resolver-container', {
                'resolver-container--rounded-top': roundTopCorners,
            })}
        >
            {children}
        </LayoutContainer>
    );
}
